export default __webpack_public_path__ + "static/media/001-overalls.0c5c76d0.svg";